import React from 'react'

const seattle = {
    id: 'seattle-olympic-peninsula',
    type: 'post',
    countryId: 'pnw',
    title: 'A Photo Journal of Seattle and the Olympic Peninsula',
    longDate: 'September 20, 2018',
    month: 'Sept',
    date: '20',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/SunriseBrinnon.jpg',
    content: [
        {
            text: (
                <div>Let me start off by saying that I totally get Derek's thing with ferry boats now, and if you don't know what I'm talking about, go ask Meredith Grey.</div>
            )
        },
        {
            text: (
                <div>I'd always assumed Seattle was fairly similar to Portland (where I'm from) – just larger and colder, both in temperature and temperament. But I totally underestimated how cool it is that the city and surrounding areas are peninsulas and islands surrounded by the Puget Sound with many inlets and lakes. A lot of people commute by ferry, and some of the major neighborhoods like Westlake are defined by their relation to the water.</div>
            )
        },
        {
            text: (
                <div>The sound separates Seattle from the Olympic Peninsula, where the gigantic Olympic National Park is. The park is about three hours including a ferry ride from the city, and when we told people in Seattle we'd just spent a week camping there, it was surprising how many of them had never made the trip out.</div>
            )
        },
        {
            text: (
                <div>Since we stayed at the same campsite for five days, I'm not going to do an entire post on Olympic National Park. It's truly huge and we barely scratched the surface; it would take years to get to all the spots on the 'best of' hiking lists. Instead, here's a mini photo-journal of our two weeks in Washington.</div>
            )
        },
        {
            text: (
                <div>I'm biased since I'm from the Pacific Northwest, but I think it's a ridiculously beautiful place to live and visit.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/OlympicNP.jpg',
            detailText: 'So. Many. Trees. Lake Crescent from the top of Pyramid Mountain.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/OlympicNP2.jpg',
            detailText: 'Another view of Lake Crescent.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Moss.jpg',
            detailText: 'Prehistoric ferns and moss on a late afternoon hike.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/LakeSunset.jpg',
            detailText: "Sunset at Lake Crescent. We stayed at Fairholme campground with our site about 30 yards from this spot – incredible. Only two campgrounds in Olympic National Park take reservations, and the rest are first come first serve. We arrived on a Monday at 1 p.m. and got the third-to-last spot. Go early in the morning and scope out people who are packing up to leave if you want to guarantee; if you can't find any spots at your top campground, Heart O' The Hills Campground is massive and will likely have a spot open."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/KayakBag.jpg',
            detailText: 'Working out how this inflatable kayak came out of its bag so we can eventually get it back in.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/KayakingLC.jpg',
            detailText: "Kayaking on the clearest water I've ever seen. You could see 20-30 feet down to where branches lay on the bottom."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/KayakingSelfie.jpg',
            detailText: 'It actually gets very hot and sunny in Seattle during the summer. Where we were camped at the northwest corner of Olympic National Park is pretty close to Forks, the town made famous as the setting of Twilight. The vampires chose it because it had the least amount of sun out of any city in the U.S. (they could have gone somewhere like Greenland but you know… no one said that book made any sense.) At least the week we were there, the weather proved Stephanie Meyer wrong.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/MossyTree.jpg',
            detailText: 'A massive, mossy tree on the path to Marymere Falls.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Farmstand.jpg',
            detailText: 'The absolute cutest farmstand outside Quilcene, selling fresh eggs and tons of veggies. It was an honor system for payment - write down what you took and put money in the box.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Clamming1.jpg',
            detailText: 'Clamming at Dosewallips State Park in Brinnon. The beach was covered in layered and crushed oyster and clamshells.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Clamming2.jpg',
            detailText: 'The tide came in crazy fast – a beach turned into an island turned into the Sound.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Clamming3.jpg',
            detailText: 'Collecting clams for dinner. You need a license to clam, but can buy one online same day. At Dosewallips we could take 40 each; each person needs their own bucket.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Dinner.jpg',
            detailText: 'Honestly, this could have been 11 a.m. or 11 p.m. Unsure.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Geoduck.jpg',
            detailText: "If you look closely in the upper right, you can see one of the famous Geoduck clam specimens. Yep… that's the one. Photo credit to Mary Byers. (Actually she probably took a lot of these.)"
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Sunset.jpg',
            detailText: "One more sunset over water photo... This pier is about two minutes from my friend Mary's apartment. Pretty cool, Seattle."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/KayakingSeattle.jpg',
            detailText: 'Kayaking right in the city.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Waffle.jpg',
            detailText: "We ate and drank many amazing things in Seattle, but somehow only this waffle got photographed. I'm clearly way more invested in taking pictures of trees. Favorite food spots so far in Seattle: Super Six for Hawaiian fusion brunch (this chicken & waffle dish was awesome), Queen Anne Beer Hall for old timey European decor and beer in a semi-Nordic warehouse, Volunteer Park Cafe for a classic artsy neighborhood cafe, No Bones Beach Club for vegan food so awesome you could just lie to the people you take there with you, and Walrus and the Carpenter for hipster seafood and the sweet Amaro bar next door that you can have a flight at while waiting for your table."
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/pnw/seattle-olympic-peninsula/Bread.jpg',
            detailText: "Maybe I would have taken more food pictures if I wasn't taking pictures of all the loaves of bread Peter baked that week."
        }
    ]
}



export default seattle


// WEBPACK FOOTER //
// ./src/Posts/Content/Seattle.js